import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { router } from "./router";
import { createQueryClient } from "./lib/query-client";
import { ErrorBoundary } from "./components/error-boundary";
import { GroundToggle, applyStoredGround } from "./components/ground-toggle";
import { Toaster } from "./components/ui/toaster";
import "./index.css";

// ADR-0138: apply the persisted ground preference before first paint so a
// non-default choice never flashes the default.
applyStoredGround();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("#root element missing from index.html");
}

const queryClient = createQueryClient();

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster />
      </QueryClientProvider>
    </ErrorBoundary>
    {/* ADR-0138: the ground preference toggle — outside the ErrorBoundary so
        grounds can be switched even on the crash screen. */}
    <GroundToggle />
  </React.StrictMode>,
);
